export default {"src":"/_next/static/media/latest-hero.b70aa30e.svg","height":36,"width":56,"blurWidth":0,"blurHeight":0};